module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "caret"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55bcfb58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Caret.vue
// module id = 275
// module chunks = 1